<div mat-dialog-content>
    <form autocomplete="off">
        <div class="row m-0 eip-pt-20">
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"  ValueField="dedShortDescription" WaterMarkText="Select Discipline" [dataSource]='discipline' [defaultValue]='' [SingleValueBind]="false" (valueChange)='selectedDiscipline($event)' [IsCascading]='true'>
                </EIPAutoComplete>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"  ValueField="dedShortDescription" WaterMarkText="Select Structure / Package" [dataSource]='structure' [defaultValue]='' (valueChange)='selectedSturcture($event)' [IsCascading]='true'>
                </EIPAutoComplete>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"  ValueField="dedId" WaterMarkText="Select DWG / DOC " [dataSource]='dwgList' [defaultValue]='' setId="dwgID" (valueChange)='selectedDwg($event)' [IsCascading]='true'>
                </EIPAutoComplete>
            </div>
            <div class="drop-down-dev">
                <button class="btn btn-primary btn-sm" (click)="getworkflowdetails()"><i class="fa fa-search" title="Search" aria-hidden="true"></i>&nbsp;&nbsp;Search</button>
            </div>
        </div>
    </form>
</div>
<div class="row m-0">
    <div class="col-12 p-0">
        <div>
            <kendo-grid [kendoGridBinding]="workflowStatusView" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMOrgList" [height]="600">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex justify-content-end">
                        <div class="eip-mt-5">
                            <mat-slide-toggle  color="primary" [(ngModel)]="isLatest" (change)="getworkflowdetails()"><span class="d-none d-md-block">Latest Revision</span>
                            </mat-slide-toggle>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">                            
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">                              
                                <div class="icon-wrap">
                                    <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap">
                                    <i class="fa fa-refresh" title="Refresh" (click)="getworkflowdetails()" aria-hidden="true"></i>
                                    <span class="list-icon-name">Refresh</span>
                                </div>
                            </div>
                            <div class="icon-wrap">
                                <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">&nbsp;&nbsp;Export to Excel</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-column title="Sl.No." width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        {{rowIndex+1}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Document No" field="doc_No" width="200">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <i aria-hidden="true" title="Attachment" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" (click)="viewAttachmentClick(dataItem)"></i><span class="no-wrap" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto">{{dataItem.doc_No}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Title" field="doc_Title" width="200">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.doc_Title}}" eipTooltipPosition="auto">{{dataItem.doc_Title}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Revision" field="revision_No" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.revision_No}}" eipTooltipPosition="auto">{{dataItem.revision_No}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Workflow Task" field="workflow_Task" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.workflow_Task}}" eipTooltipPosition="auto">{{dataItem.workflow_Task}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Assigned To" field="member_Name" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.member_Name}}" eipTooltipPosition="auto">{{dataItem.member_Name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Assigned On" field="assigned_On" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.assigned_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.assigned_On | date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Completion Status" field="action_Status" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.action_Status}}" eipTooltipPosition="auto">{{dataItem.action_Status}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Checklist" width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="icon-container"><i aria-hidden="true"  class="fa fa-imr-wo eip-link" style="font-size: 1.25em; cursor: pointer;" title="View Checklist" (click)="onClick_WorkflowCheckList(dataItem)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="CCN" width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="icon-container"><i aria-hidden="true"  class="fa fa-notes eip-link" style="font-size: 1.25em; cursor: pointer;" title="View Change Control Note" (click)="openCCN(dataItem)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Tender Quantity" width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="icon-container"><i aria-hidden="true" class="fa fa-budget eip-link" style="font-size: 1.25em; cursor: pointer;" title="View Tender Quantity" (click)="openTQ(dataItem)" value="Tender Qty"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="History" width="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="icon-container"><i aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"  class="fa fa fa-history eip-link" title="View Workflow History" (click)="onClick_WorkflowHistory(dataItem)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-excel fileName="WorkflowStatusList.xlsx" [fetchData]="allData"></kendo-grid-excel>
            </kendo-grid>
        </div>
    </div>